import React from "react";
import "./WishList.css";
import { useProduct } from "../../contexts";
import { addItemToCart, addOrRemoveFromWish } from "../../server";
import {
  ProductImage,
  ProductName,
  PrimaryButton,
  ProductContent,
} from "../index";
import useToastCleaner from "../../utils/useToastCleaner";
import { useDocumentTitle } from "../../utils";

function WishList({ loading }) {
  const {
    state: { wishList, cartList },
    dispatch,
  } = useProduct();
  useToastCleaner();
  useDocumentTitle("Wishlist");

  const addItemToCartList = (product) => {
    removeFromWishList(product);
    addItemToCart(dispatch, product, cartList);
  };

  const removeFromWishList = (product) => {
    addOrRemoveFromWish(dispatch, product, wishList);
  };

  return (
    <>
      <div className="h5 text--bold spacing text--center"> Your Wishlist </div>
      {wishList.length === 0 && (
        <div className="text--center h6 text--gray">Your wishlist is empty</div>
      )}
      {loading ? (
        <span className="loading"></span>
      ) : (
        <div className="product-showcase wishlist--margin">
          {wishList.map((product) => {
            const { id, name, image, price, brand, offer, inStock, ratings } =
              product;
            return (
              <div key={id} className="card card--product">
                <div className={`card__badge badge--position`}>
                  <i
                    className={`fas fa-heart fa-lg `}
                    onClick={() => removeFromWishList(product)}
                  ></i>
                </div>
                <ProductImage image={image} inStock={inStock} />
                <ProductName name={name} ratings={ratings} />
                <div className="card__content card__content--align">
                  <ProductContent price={price} brand={brand} offer={offer} />
                  <PrimaryButton
                    inStock={inStock}
                    className={inStock ? "" : "out-of-stock"}
                    onClick={() => addItemToCartList(product)}
                  >
                    {inStock ? "Move to Cart" : "Out of Stock"}
                  </PrimaryButton>
                </div>
              </div>
            );
          })}
        </div>
      )}
    </>
  );
}

export default WishList;
